export class AuditResultListSummary {
    public TotalAudits: number = 0;
    public OutstandingActions: number = 0;
    public OverdueActions: number = 0;
    public CompletedActions: number = 0;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
